import React from "react";
import { X } from "lucide-react";

interface MobileNotificationBannerProps {
  message: string;
  onDismiss?: () => void;
}

export default function MobileNotificationBanner({
  message,
  onDismiss,
}: MobileNotificationBannerProps) {
  return (
    <div className="bg-yellow-400 px-4 py-3 flex items-center justify-between">
      <p className="text-sm text-gray-900 flex-1 pr-2">{message}</p>
      <button
        onClick={onDismiss}
        className="ml-2 p-1 hover:bg-yellow-300 rounded-full flex-shrink-0"
      >
        <X className="w-4 h-4 text-gray-700" />
      </button>
    </div>
  );
}
